import { render, staticRenderFns } from "./mainlandfreight-add.vue?vue&type=template&id=1ed05fb6&"
import script from "./mainlandfreight-add.vue?vue&type=script&lang=ts&"
export * from "./mainlandfreight-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports